import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from 'primeng/api';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from 'primeng/confirmdialog';
import { PrimengLibraryModule } from 'primeng-library';

class SaveAsDraftService {
    constructor() { }
}
SaveAsDraftService.ɵfac = function SaveAsDraftService_Factory(t) { return new (t || SaveAsDraftService)(); };
SaveAsDraftService.ɵprov = i0.ɵɵdefineInjectable({ token: SaveAsDraftService, factory: SaveAsDraftService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SaveAsDraftService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function SaveAsDraftComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 3);
} }
const _c0 = function (a0) { return { "button-width-icon-left": a0 }; };
class SaveAsDraftComponent {
    constructor(confirmationService) {
        this.confirmationService = confirmationService;
        this.disabled = false;
        this.showSaveIcon = false;
        this.buttonLabel = 'Save as Draft';
        this.styleClass = 'btn btn-success';
        this.onClickSaveAsDraft = new EventEmitter();
        this.confirmModelKey = 'saveasdraft';
        this.confirmModelHeader = 'Confirm Save';
        this.confirmModelMessage = 'Required field(s) are missing. Do you still want to continue to save?';
    }
    ngOnInit() {
    }
    saveAsDraft() {
        // console.log(this.formToBeSaved, this.formToBeSaved['valid'],this.formToBeSaved['invalid']);
        if (this.formToBeSaved && this.formToBeSaved['valid']) {
            this.onClickSaveAsDraft.emit(false);
        }
        if (this.formToBeSaved && this.formToBeSaved['invalid']) {
            this.confirmationService.confirm({
                icon: 'red-astrix required pt-1',
                message: this.confirmModelMessage,
                key: this.confirmModelKey,
                accept: () => {
                    this.onClickSaveAsDraft.emit(true);
                },
                reject: () => {
                }
            });
        }
    }
}
SaveAsDraftComponent.ɵfac = function SaveAsDraftComponent_Factory(t) { return new (t || SaveAsDraftComponent)(i0.ɵɵdirectiveInject(i1.ConfirmationService)); };
SaveAsDraftComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SaveAsDraftComponent, selectors: [["lib-save-as-draft"]], inputs: { disabled: "disabled", showSaveIcon: "showSaveIcon", formToBeSaved: "formToBeSaved", buttonLabel: "buttonLabel", styleClass: "styleClass", confirmModelKey: "confirmModelKey" }, outputs: { onClickSaveAsDraft: "onClickSaveAsDraft" }, decls: 4, vars: 10, consts: [["type", "button", 3, "ngClass", "disabled", "click"], ["class", "fa fa-floppy-o", 4, "ngIf"], [1, "draft-save-confirm", 3, "header", "key"], [1, "fa", "fa-floppy-o"]], template: function SaveAsDraftComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function SaveAsDraftComponent_Template_button_click_0_listener() { return ctx.saveAsDraft(); });
        i0.ɵɵtemplate(1, SaveAsDraftComponent_i_1_Template, 1, 0, "i", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "p-confirmDialog", 2);
    } if (rf & 2) {
        i0.ɵɵclassMap(ctx.styleClass);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx.showSaveIcon))("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSaveIcon);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.buttonLabel, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("header", ctx.confirmModelHeader)("key", ctx.confirmModelKey);
    } }, directives: [i2.NgClass, i2.NgIf, i3.ConfirmDialog], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SaveAsDraftComponent, [{
        type: Component,
        args: [{
                selector: 'lib-save-as-draft',
                template: `
  <button type="button" [class]="styleClass" [ngClass]="{'button-width-icon-left': showSaveIcon}" (click)="saveAsDraft()" [disabled]="disabled">
    <i *ngIf="showSaveIcon" class="fa fa-floppy-o"></i>
    {{buttonLabel}}
  </button>
  <p-confirmDialog class="draft-save-confirm" [header]="confirmModelHeader" [key]="confirmModelKey"></p-confirmDialog>
  `,
                styles: []
            }]
    }], function () { return [{ type: i1.ConfirmationService }]; }, { disabled: [{
            type: Input
        }], showSaveIcon: [{
            type: Input
        }], formToBeSaved: [{
            type: Input
        }], buttonLabel: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], onClickSaveAsDraft: [{
            type: Output
        }], confirmModelKey: [{
            type: Input
        }] }); })();

class SaveAsDraftModule {
}
SaveAsDraftModule.ɵfac = function SaveAsDraftModule_Factory(t) { return new (t || SaveAsDraftModule)(); };
SaveAsDraftModule.ɵmod = i0.ɵɵdefineNgModule({ type: SaveAsDraftModule });
SaveAsDraftModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SaveAsDraftModule, { declarations: [SaveAsDraftComponent], imports: [CommonModule,
        PrimengLibraryModule], exports: [SaveAsDraftComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SaveAsDraftModule, [{
        type: NgModule,
        args: [{
                declarations: [SaveAsDraftComponent],
                imports: [
                    CommonModule,
                    PrimengLibraryModule
                ],
                exports: [SaveAsDraftComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of save-as-draft
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SaveAsDraftComponent, SaveAsDraftModule, SaveAsDraftService };
//# sourceMappingURL=save-as-draft.js.map
